import styled from '@emotion/styled';
import { TypographyVariant, TypographyFontWeight, TypographyFontFamily } from './typography.types';
import { css } from '@emotion/react';

export const Typography = styled.p<{
  $variant: TypographyVariant;
  $fontWeight?: TypographyFontWeight;
  $fontFamily: TypographyFontFamily;
}>`
  margin: 0;
  padding: 0;

  /* Pull typography styles from theme based on variant */
  ${({ theme, $variant, $fontWeight, $fontFamily }) => {
    if (!theme.typography || !theme.typography[$variant]) {
      // Only warn in development
      if (process.env.NODE_ENV === 'development') {
        
      }
      return '';
    }

    const variantStyle = theme.typography[$variant];

    return css`
      font-size: ${variantStyle.fontSize};
      font-weight: ${$fontWeight || variantStyle.fontWeight};
      line-height: ${variantStyle.lineHeight};
      letter-spacing: ${variantStyle.letterSpacing || 'normal'};
      font-family: ${$fontFamily}, sans-serif;
    `;
  }}
`;
